import React, { useState } from "react";
import { TableRow, TableCell } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  ModalDefaultError,
  ModalDeleteConfirm,
  TableAction,
  TableWrapper,
  TableCellDefault,
  IconButtonDatatable,
} from "App/Component/ui";

import { useDatatables, useFetch } from "App/hooks";
import {
  ModalForm,
  headCells,
  deleteRuangAplicareById,
  RESET_STATE_RUANG_APLICARES,
  urlGet,
} from "./helpers";
import { TYPE_INSTANCE2 } from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
} from "App/utils/helpers";
import { SelectIcon } from "App/Assets";

export default function TabRuangAplicares() {
  const [showModal, setShowModal] = useState(false);
  const [showModalDefaultError, setShowModalDefaultError] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [rows, setRows] = useFetch(TYPE_INSTANCE2, urlGet);

  const [formData, setFormData] = useState(RESET_STATE_RUANG_APLICARES);

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  function clickAdd() {
    setFormData(RESET_STATE_RUANG_APLICARES);
    setShowModal(!showModal);
  }

  function clickUpdate(row) {
    setFormData({
      id: row?.id,
      name: row?.name,
      kode: row?.kode,
      remark: row?.remark,
    });

    setShowModal(true);
  }

  function clickDelete(row) {
    setFormData({
      ...formData,
      id: row?.id,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  async function setNewData() {
    const res = await fetchData(TYPE_INSTANCE2, urlGet);
    setRows(res);
  }

  async function deleteList() {
    const res = await deleteRuangAplicareById(formData.id);

    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  return (
    <>
      {showModal && (
        <ModalForm
          setNewData={setNewData}
          setShowModal={() => setShowModal(false)}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {showModalDefaultError && (
        <ModalDefaultError
          setShowModalDefaultError={() => setShowModalDefaultError(true)}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <TableWrapper
        title='Daftar Ruang Aplicares & RS Online'
        setQ={setQ}
        clickAddButton={() => clickAdd()}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRowRuangAplicare
                clickDelete={clickDelete}
                clickUpdate={clickUpdate}
                index={index}
                row={row}
                isSelect={false}
                key={index}
              />
            );
          })}
      </TableWrapper>
    </>
  );
}

export const TableRowRuangAplicare = ({
  isSelect = false,
  isDelete = true,
  isUpdate = true,
  row,
  clickDelete,
  clickUpdate,
  clickSelect,
  index,
}) => {
  return (
    <TableRow
      hover
      tabIndex={-1}
      key={index}
      style={{
        backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
      }}>
      <TableCell component='th' scope='row' padding='none' align='center'>
        {index + 1}
      </TableCell>

      <TableCell component='th' scope='row' padding='none' width={"5%"}>
        {isSelect ? (
          <IconButtonDatatable onClick={() => clickSelect(row)}>
            <SelectIcon width={"16"} height={"16"} fill={"#fff"} />
          </IconButtonDatatable>
        ) : (
          <TableAction
            clickDelete={() => clickDelete(row)}
            clickUpdate={() => clickUpdate(row)}
            isDelete={isDelete}
            isUpdate={isUpdate}
          />
        )}
      </TableCell>
      <TableCell align='left'>{row?.id}</TableCell>

      <TableCell align='left' width={"5%"}>
        {row?.kode}
      </TableCell>

      <TableCell align='left' width={"5%"}> {row?.kode_sirsonline ?? '-'} </TableCell>
      <TableCell align='left'>{row?.name}</TableCell>
      <TableCellDefault row={row} />
    </TableRow>
  );
};
